let graphemeSegmenter;
function getFirstCharacter(str) {
  if (!str) return "";
  graphemeSegmenter ??= new Intl.Segmenter(void 0, { granularity: "grapheme" });
  for (const { segment } of graphemeSegmenter.segment(str)) {
    return segment;
  }
  return "";
}
export {
  getFirstCharacter
};
//# sourceMappingURL=string.mjs.map
